import { TokenService } from "../modules/shared/service/token.service";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import * as _  from 'lodash';
import { Permission } from "../modules/shared/enums/enums";

@Injectable()
export class PermissionsService {

  private permissions: string[];

  constructor(private tokenService: TokenService, private router: Router) {
    this.permissions = [];
  }

  public isPermitted(componentPermissions: Permission[]): boolean {
    this.permissions = this.tokenService.getPermissions();
    if (this.permissions.length > 0) {
        const intersectionCount = _.intersectionBy(componentPermissions, this.permissions, toString).length;
        return componentPermissions.length === 0 || intersectionCount === componentPermissions.length;
    }
    return false;
  }

  public navigateToForbiddenPage(permission: Permission) {
    this.router.navigateByUrl('/forbidden-page?permission=' + permission);
  }
}

